import React, { useEffect, useState } from 'react';
import Message from '../LoadingError/Error';
import Toast from './../LoadingError/Toast';
import Loading from './../LoadingError/Loading';
import { updateUser } from '../../service/UserService';

const ProfileTabs = ({ user }) => {
  const [userProfile, setUserProfile] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    flat: '',
    zipCode: '',
    city: '',
    country: '',
  });
  // const [password, setPassword] = useState('');
  // const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [updateLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setUserProfile({
        name: user.name,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        address: user.address,
        flat: user.flat,
        zipCode: user.zipCode,
        city: user.city,
        country: user.country,
      });
      setLoading(false);
    }
  }, [user]);

  const handleUserProfile = (input) => {
    setUserProfile({ ...userProfile, [input.name]: input.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    updateUser(userProfile)
      .then(() => {
        setLoading(false);
        window.location.reload();
      })
      .catch((error) => {
        setError(error.response.data.message);
      });

    // Password match
    // if (password !== confirmPassword) {
    //   if (!toast.isActive(toastId.current)) {
    //     toastId.current = toast.error('Password does not match', Toastobjects);
    //   }
    // } else {
    //   dispatch(updateUserProfile({ id: user._id, name, email, password }));
    //   if (!toast.isActive(toastId.current)) {
    //     toastId.current = toast.success('Profile Updated', Toastobjects);
    //   }
    // }
  };

  return (
    <>
      <Toast />
      {error && <Message variant='alert-danger'>{error}</Message>}
      {loading && <Loading />}
      {updateLoading && <Loading />}
      <form className='row  form-container' onSubmit={submitHandler}>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-fn'>Nombre</label>
            <input
              className='form-control'
              type='text'
              required
              value={userProfile.name}
              name='name'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-fn'>Apellido</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.lastName}
              name='lastName'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>

        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>Dirección de E-mail</label>
            <input
              className='form-control'
              type='email'
              value={userProfile.email}
              required
              name='email'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>Teléfono</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.phone}
              name='phone'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-12'>
          <div className='form'>
            <label htmlFor='account-email'>Dirección</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.address}
              name='address'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>Piso</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.flat}
              name='flat'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>Código Postal</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.zipCode}
              name='zipCode'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>Ciudad</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.city}
              name='city'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-email'>País</label>
            <input
              className='form-control'
              type='text'
              value={userProfile.country}
              name='country'
              onChange={(e) => handleUserProfile(e.target)}
            />
          </div>
        </div>
        {/* <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-pass'>New Password</label>
            <input
              className='form-control'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target)}
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form'>
            <label htmlFor='account-confirm-pass'>Confirm Password</label>
            <input
              className='form-control'
              type='password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target)}
            />
          </div>
        </div> */}
        <button type='submit'>Actualizar el Perfil</button>
      </form>
    </>
  );
};

export default ProfileTabs;
